import React, { useState, useEffect } from "react";
import Header from "../../../layouts/doctor/DoctorHeader";
import {
  getDocdsplyDetails,
  getLocationDetails,
} from "../../../api/userApi/userApi";
import useEncryption from "../../../services/useEncryption";
import { useOutletContext, useParams } from "react-router-dom";
import useHeaders from "../../../helpers/useHeaders";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import path from "../../../path";
import useToast from "../../../helpers/useToast";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  Grid,
  Container,
  Rating,
  Button,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import StarIcon from "@mui/icons-material/Star";
import UpdateLocDsplyModal from "./UpdateLocDsplyModal";
import UpdateAboutModal from "./UpdateAboutModal";
import UpdateInsuranceModal from "./UpdateInsuranceModal";
import { cleanDigitSectionValue } from "@mui/x-date-pickers/internals/hooks/useField/useField.utils";

const LocationDetails = () => {
  const userRole = useSelector((state) => state.auth.role);
  
  const [locationData, setLocationData] = useState(null);
  const headers = useHeaders();
  const toastOptions = useToast();
  const { id } = useParams();
  const { encryptData, decryptData } = useEncryption();
  const decryptedId = decryptData(decodeURIComponent(id));
  const [loading, setLoading] = useOutletContext();
  const [open, setOpen] = useState(false);
  const [update, setUpdate] = useState(false);
  const [locationDispData, setlocationDispData] = useState(null);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [insuranceOpen, setInsuranceOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleAboutClickOpen = () => {
    setAboutOpen(true);
  };
  const handleAboutClose = () => {
    setAboutOpen(false);
  };

  const handleinsurancesClickOpen = () => {
    setInsuranceOpen(true);
  };
  const handleInsuranceClose = () => {
    setInsuranceOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getLocationDetails(decryptedId, headers);
        let decryptedData = decryptData(response?.data?.data);
        // const docResponse = await getDocdsplyDetails(
        //   decryptedData?.providerId,
        //   headers
        // );

        setLocationData(decryptedData);
        setlocationDispData(decryptedData);

        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error(error.response.data.message, toastOptions);
      }
    };

    fetchData();
  }, [update]);
  return (
    <div>
      <Header pageTitle="Location" />
      <div className="cardOuter">
        <div className="cardheads">
          <div className="cardTitle">Location</div>
          {(userRole === "provider" || userRole === "doctor" ||userRole === "location") && (
            <button className="btn blackoutlineBtn" onClick={handleClickOpen}>
              Edit Display Details
            </button>
          )}
        </div>
        <Container maxWidth="sm">
          <Card
            variant="outlined"
            sx={{ display: "flex", alignItems: "center", p: 2, mb: 3, mt: 3 }}
          >
            <Box
              sx={{
                width: 80,
                height: 80,
                mr: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 24,
                fontWeight: "bold",
                backgroundColor: "#e0e0e0",
                borderRadius: "50%",
                overflow: "hidden",
              }}
            >
              {locationData?.doctor?.photo ? (
                <img
                  alt={locationData?.doctor?.firstName}
                  src={`${path}/${locationData.doctor.photo.replace(
                    "public/images/UserIcons/",
                    ""
                  )}`}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                <span>{locationData?.doctor?.firstName?.charAt(0)}</span>
              )}
            </Box>

            <CardContent sx={{ flex: 1 }}>
              <Typography
                variant="h6"
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                Dr.{" "}
                {`${locationData?.doctor?.firstName
                  .charAt(0)
                  .toUpperCase()}${locationData?.doctor?.firstName
                  .slice(1)
                  .toLowerCase()}`}
                {` ${locationData?.doctor?.lastName
                  .charAt(0)
                  .toUpperCase()}${locationData?.doctor?.lastName
                  .slice(1)
                  .toLowerCase()}`}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {locationData?.providerName}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                <LocationOnIcon fontSize="small" color="action" />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ ml: 0.5 }}
                >
                  {locationData?.city}, {locationData?.state},{" "}
                  {locationData?.country} {locationData?.zipCode}
                </Typography>
              </Box>
            </CardContent>
          </Card>

          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: "bold",
              mb: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between", // This aligns children to ends
            }}
          >
            <span>About</span>
            {/* {(userRole === "provider" || userRole === "doctor") && (
              <Button
                variant="outlined"
                startIcon={<EditOutlinedIcon />}
                size="small"
                sx={{
                  borderColor: "#222",
                  color: "#222",
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: 13,
                  padding: "2px 14px",
                  minWidth: 70,
                  "&:hover": {
                    borderColor: "#111",
                    backgroundColor: "#f5f5f5",
                  },
                }}
                onClick={handleAboutClickOpen}
              >
                Edit
              </Button>
            )} */}
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            {locationData?.doctor?.aboutMe}
          </Typography>

          {/* In-network Insurances Section */}
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: "bold",
              mt: 3,
              mb: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between", // aligns children to ends
            }}
          >
            <span>In-network insurances</span>
            {/* {(userRole === "provider" || userRole === "doctor") && (
              <Button
                variant="outlined"
                startIcon={<EditOutlinedIcon />}
                size="small"
                sx={{
                  borderColor: "#222",
                  color: "#222",
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: 13,
                  padding: "2px 14px",
                  minWidth: 70,
                  "&:hover": {
                    borderColor: "#111",
                    backgroundColor: "#f5f5f5",
                  },
                }}
                onClick={handleinsurancesClickOpen}
              >
                Edit
              </Button>
            )} */}
          </Typography>
          <div className="insurance-grid">
            {locationData?.doctor?.insurance_details?.map((data, index) => (
              <div className="insurance-item" key={index}>
                <div className="insurance-logo"></div>
                <span className="insurance-name">{data}</span>
              </div>
            ))}
          </div>
        </Container>
      </div>

      <UpdateLocDsplyModal
        open={open}
        userId={locationData?.doctor?.organizationId || ""}
        handleClose={handleClose}
        setUpdate={setUpdate}
        locDisData={locationDispData}
      />

      <UpdateAboutModal
        open={aboutOpen}
        handleClose={handleAboutClose}
        aboutMe={locationData?.doctor?.aboutMe || ""}
        userId={locationData?.doctor?.organizationId || ""}
        setUpdate={setUpdate}
        doctorData={{
          firstName: locationData?.doctor?.firstName || "",
          lastName: locationData?.doctor?.lastName || "",
          streetAddress: locationData?.streetAddress || "",
          city: locationData?.city || "",
          state: locationData?.state || "",
          country: locationData?.country || "",
          zipCode: locationData?.zipCode || "",
          insurance_details: locationData?.doctor?.insurance_details || [],
          photo: locationData?.doctor?.photo || null,
        }}
      />

      <UpdateInsuranceModal
        open={insuranceOpen}
        handleClose={handleInsuranceClose}
        insuranceDetails={locationData?.doctor?.insurance_details || []}
        userId={locationData?.doctor?.organizationId || ""}
        setUpdate={setUpdate}
        doctorData={{
          firstName: locationData?.doctor?.firstName || "",
          lastName: locationData?.doctor?.lastName || "",
          streetAddress: locationData?.streetAddress || "",
          city: locationData?.city || "",
          state: locationData?.state || "",
          country: locationData?.country || "",
          zipCode: locationData?.zipCode || "",
          aboutMe: locationData?.doctor?.aboutMe || "",
          insurance_details: locationData?.doctor?.insurance_details || [],
          photo: locationData?.doctor?.photo || null,
        }}
      />
    </div>
  );
};

export default LocationDetails;
